function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import useAsset from '../components/hook/useAsset';
import { CACHE_KEYS } from './config';
import { api } from './swaggerApi';
export var update = function(identifier, data) {
    return axios.put("/insights_platform/campaign_qualifications/".concat(identifier), data);
};
export var create = function(data) {
    return axios.post("/insights_platform/campaign_qualifications/", data);
};
export var destroy = function(identifier) {
    return axios.delete("/insights_platform/campaign_qualifications/".concat(identifier));
};
var campaignQualificationUpdater = function() {
    var _ref = _async_to_generator(function(queryClient, quotaIdentifier, updater) {
        var previous;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.cancelQueries([
                            CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                            quotaIdentifier
                        ])
                    ];
                case 1:
                    _state.sent();
                    previous = queryClient.getQueryData([
                        CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                        quotaIdentifier
                    ]);
                    queryClient.setQueryData([
                        CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                        quotaIdentifier
                    ], function(old) {
                        return updater(old);
                    });
                    return [
                        2,
                        {
                            previous: previous
                        }
                    ];
            }
        });
    });
    return function campaignQualificationUpdater(queryClient, quotaIdentifier, updater) {
        return _ref.apply(this, arguments);
    };
}();
export var useUpdateCampaignQualification = function(quotaIdentifier, identifier) {
    var queryClient = useQueryClient();
    var mutation = useMutation(function(data) {
        return update(identifier, data);
    }, {
        // Optimistic update
        onMutate: function() {
            var _ref = _async_to_generator(function(data) {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        campaignQualificationUpdater(queryClient, quotaIdentifier, function(old) {
                            var newCqs = old.data.data.map(function(cq) {
                                if (cq.attributes.identifier === identifier) {
                                    return _object_spread_props(_object_spread({}, cq), {
                                        attributes: _object_spread({}, cq.attributes, data)
                                    });
                                }
                                return cq;
                            });
                            return {
                                data: {
                                    data: newCqs
                                }
                            };
                        })
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: function(err, newTodo, context) {
            queryClient.setQueryData([
                CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                quotaIdentifier
            ], context.previous);
        },
        // Always refetch after error or success:
        onSettled: function() {
            queryClient.invalidateQueries([
                CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                quotaIdentifier
            ]);
        }
    });
    return mutation;
};
export var useCreateCampaignQualification = function(quotaIdentifier) {
    var queryClient = useQueryClient();
    var mutation = useMutation(function(data) {
        return create(_object_spread_props(_object_spread({}, data), {
            qualifiable_identifier: quotaIdentifier
        }));
    }, {
        // Optimistic update
        onMutate: function() {
            var _ref = _async_to_generator(function(data) {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        campaignQualificationUpdater(queryClient, quotaIdentifier, function(old) {
                            return _object_spread_props(_object_spread({}, old), {
                                data: _object_spread_props(_object_spread({}, old.data), {
                                    data: _to_consumable_array(old.data.data).concat([
                                        {
                                            attributes: data
                                        }
                                    ])
                                })
                            });
                        })
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: function(err, newTodo, context) {
            queryClient.setQueryData([
                CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                quotaIdentifier
            ], context.previous);
        },
        // Always refetch after error or success:
        onSettled: function() {
            queryClient.invalidateQueries([
                CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                quotaIdentifier
            ]);
        }
    });
    return mutation;
};
export var useDestroyCampaignQualification = function(quotaIdentifier, identifier) {
    var queryClient = useQueryClient();
    var mutation = useMutation(function() {
        return destroy(identifier);
    }, {
        // Optimistic update
        onMutate: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    campaignQualificationUpdater(queryClient, quotaIdentifier, function(old) {
                        var newCqs = old.data.data.reduce(function(acc, cq) {
                            if (cq.attributes.identifier !== identifier) {
                                acc.push(cq);
                            }
                            return acc;
                        }, []);
                        return _object_spread_props(_object_spread({}, old), {
                            data: _object_spread_props(_object_spread({}, old.data), {
                                data: newCqs
                            })
                        });
                    })
                ];
            });
        }),
        onSuccess: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                queryClient.refetchQueries([
                    CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
                    quotaIdentifier
                ]);
                return [
                    2
                ];
            });
        })
    });
    return mutation;
};
export var useGetCampaignQualifications = function(quotaIdentifier, queryOptions) {
    return useQuery([
        CACHE_KEYS.CAMPAIGN_QUALIFICATIONS,
        quotaIdentifier
    ], function() {
        return api.insightsPlatform.campaignQualificationsList({
            qualifiable_identifier: quotaIdentifier
        });
    }, queryOptions);
};
export var useGetDemographicCampaignQualifications = function(quotaIdentifier, queryOptions) {
    var asset = useAsset();
    var query = useGetCampaignQualifications(quotaIdentifier, queryOptions);
    var cqs = query.isSuccess ? query.data.data.data.filter(function(cq) {
        return ![
            asset.constants.FS_GENDER_QID,
            asset.constants.FS_AGE_QID
        ].includes(cq.attributes.question_id);
    }) : undefined;
    return _object_spread_props(_object_spread({}, query), {
        data: cqs
    });
};
